<template>
    <div class="custom-checkobx">
        <span v-bind:hidden="!isHidden" v-bind:style="{ 'background-color': backgroundColor }">{{ letter }}</span>
        <div class="custom-checkobx-input" v-on:click="clickCheckbox" v-bind:visible="checkbox">
            <v-icon v-bind:hidden="!checkbox">check_box</v-icon>
            <v-icon v-bind:hidden="checkbox">check_box_outline_blank</v-icon>
            <input ref="realCheckbox" type="checkbox" style="display: none;" v-model="checkbox"  />
        </div>
    </div>
</template>


<script>

import ColorGenerator from '../../services/ColorGenerator.js'

export default {
    name: "CustomCheckbox",
    data() {
        return {
            isHidden: true,
            checkbox: false,
            backgroundColor: 'None',
            chkName: 'chk'
        }
    },
    methods: {
        clickCheckbox() {
            this.checkbox = !this.checkbox;
            this.isHidden = !this.checkbox;
            this.$emit('change', this.checkbox);
        }
    },
    props: {
        entityId: Number,
        letter: String,
        overrideColor: String
    },
    created() {
        if (!this.overrideColor) {
            this.backgroundColor = ColorGenerator.getNextWhiteFontRGB(this.letter);
        }
        else {
            this.backgroundColor = this.overrideColor;
        }
        this.chkName = 'chk' + this.entityId;
    }
}
</script>

<style lang="stylus">
    .custom-checkobx {
        position: relative;
        width: 28px;
        height 28px;
        padding: 0 22px; 
        cursor: pointer;
    }

    .custom-checkobx > span {
        position: absolute;
        width: 28px;
        height 28px;
        border-radius: 50%;
        display: block;
        top: 0;
        left: 0;
        color: #fff;
        text-align: center;
        line-height: 28px;
        font-size: 13px;
        text-transform: uppercase;
    }
    .custom-checkobx:hover > span {
        display:none;
    }

    .custom-checkobx > .custom-checkobx-input {
        display: none;
        position:absolute;
        top: 0;
        left: 0;
        width: 28px;
        height 28px; 
        padding-top: 2px;
        padding-left: 2px;
    }

    .custom-checkobx:hover > .custom-checkobx-input {
        display: block;
    }

    .custom-checkobx > [hidden] {
        display:none;
    }

    .custom-checkobx > .custom-checkobx-input[visible] {
        display: block;
    }
</style>
